/**
 * phi-fields.ts — canonical PHI field denylist, dependency-free.
 *
 * Extracted from safe-logger so it can be imported in ANY runtime, including
 * browser bundles (safe-logger itself pulls node:async_hooks via correlation
 * context and is not browser-safe). This is the SINGLE SOURCE OF TRUTH for the
 * denylist — the Node Sentry scrubber (@nrx/error-tracking), the browser Sentry
 * scrubber, safe-logger, and tests all import it from here.
 *
 * Source: HIPAA Privacy Rule Safe Harbor identifiers + Betty-specific PHI fields.
 */
export const PHI_FIELD_DENYLIST = [
  // HIPAA Safe Harbor identifiers (names, geography, dates, contacts)
  'name',
  'firstName',
  'lastName',
  'fullName',
  'dob',
  'dateOfBirth',
  'birthDate',
  'address',
  'street',
  'city',
  'state',
  'zip',
  'postalCode',
  'phone',
  'phoneNumber',
  'mobile',
  'fax',
  'email',
  'emailAddress',
  'ssn',
  'socialSecurityNumber',
  'ssnLast4',
  // Medicare / clinical identifiers
  'mbi',
  'medicareId',
  'medicareNumber',
  'beneficiaryId',
  'npi',
  // Betty PHI fields
  'memberId',
  'memberUlid',
  'patientExternalId',
  'providerId',
  'labValue',
  'hba1c',
  'egfr',
  'uacr',
  'ldlc',
  'bloodPressure',
  'weight',
  'bmi',
  'conditionCode',
  'diagnosisCode',
  'icd10',
  // Auth/session (PII — scrub anyway)
  'accessToken',
  'refreshToken',
  'idToken',
  'password',
  'secret',
] as const;
